import React from 'react';

export class SelectSideItem extends React.PureComponent {
  render() {
    return(
      <div
        style={{ flex: 0, padding: '1vw'}}
        onChange={(e) => this.props.onSelectSideChange(e.target.value) }>
        <select id='select-side' defaultValue={'choose'}>
          <option value={'choose'} key={'096/875652'}>Choisir une table</option>
          {this.props.optionsSide}
        </select>
      </div>
    )
  }
}